// Invitations a rejoindre un club recues par un coach : tant qu'il ne l'a
// pas acceptee, il reste dans son club actuel (ClubService.accepterInvitation).
import * as React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { accepterInvitationClub, refuserInvitationClub, type InvitationClub } from './moi.ts';

export default function InvitationsClub({ invitations }: { invitations: InvitationClub[] }) {
  // Plus tard : la fenetre reviendra a la prochaine connexion.
  const [plusTard, setPlusTard] = React.useState(false);
  const [enCours, setEnCours] = React.useState(false);
  const [erreur, setErreur] = React.useState<string | null>(null);
  const invitation = invitations[0];

  const repondre = async (action: (id: string) => Promise<unknown>) => {
    setEnCours(true);
    setErreur(null);
    try {
      await action(invitation.id);
    } catch (e) {
      setErreur((e as Error).message);
    } finally {
      setEnCours(false);
    }
  };

  if (!invitation || plusTard) return null;
  const club = invitation.club || 'Un club';

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <DialogTitle>Invitation d'un club</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          <b>{club}</b> t'invite à rejoindre ses coachs.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Si tu acceptes, tu partageras la bibliothèque de séances du club et tes athlètes deviendront membres du club.
          Tu quittes ton club actuel : si tu en étais le seul coach, sa bibliothèque redevient tes séances personnelles.
        </Typography>
        {invitations.length > 1 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Tu as {invitations.length} invitations : accepter celle-ci supprime les autres.
          </Typography>
        )}
        {erreur && <Alert severity="error" sx={{ mt: 2 }}>{erreur}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={() => setPlusTard(true)} disabled={enCours}>Plus tard</Button>
        <Button color="error" onClick={() => repondre(refuserInvitationClub)} disabled={enCours}>Refuser</Button>
        <Button variant="contained" onClick={() => repondre(accepterInvitationClub)} disabled={enCours}>Accepter</Button>
      </DialogActions>
    </Dialog>
  );
}
